import dayjs from 'dayjs';
import { IGlobalPromotionText } from './types';

const globalPromotionInfo: IGlobalPromotionText[] = [{
    textKey: 'subscribe.thanks_promotion',
    moreInfoKey: 'subscribe.thanks_promotion_more',
    code: 'BUY-UPGRADED',
    startTime: '2025-12-24',
    endTime: '2025-12-26'
}];

export const subscribeConfig = {
    globalPromotionInfo: globalPromotionInfo.filter( info => {

        const startTime = dayjs( info.startTime );
        const endTime = dayjs( info.endTime );
        const now = dayjs();
        return now.isAfter( startTime ) && now.isBefore( endTime );

    }),
};
